import React from "react";
import StandardLayout from "components/Library/Layout/containers/StandardLayout";
import BrandedDeepDiveHeader from "stream/components/BrandedDeepDiveHeader";
import LatestStories from "components/Library/LatestStories";
import StreamAd from "stream/containers/StreamAd";
import { BRANDED_DEEP_DIVES } from "config/constants";

export default function BrandedDeepDive({ match }) {
  const brandedDeepDive = BRANDED_DEEP_DIVES[match.params.adPath];

  return (
    <StandardLayout
      main={
        <>
          {brandedDeepDive.header ? (
            <BrandedDeepDiveHeader {...brandedDeepDive.header} />
          ) : null}
          <div>
            {[...Array(20).keys()].map(num => (
              <StreamAd
                key={num}
                node={{
                  adUnit: "section-sponsored",
                  targeting: {
                    "stream-name": brandedDeepDive.streamName,
                    "stream-pos": `pos${num + 1}`,
                  },
                }}
              />
            ))}
          </div>
        </>
      }
      complementary={<LatestStories />}
      mainAriaLabel="Branded Deep Dive Stories"
    />
  );
}
